import React, { Component } from 'react'; //different
import './App.css';
import Footer from './footer';
import jwt_decode from "jwt-decode";
import Swal from 'sweetalert2'
import instance from "./axios-instance";
import { NumericFormat } from 'react-number-format';
import Systems from "./SystemFunction";
import moment from 'moment';
import md5 from 'md5';
import { ToastContainer, toast } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import { t } from './i18n';
class App extends Component {
  get lang() { return localStorage.getItem('lang') || 'th'; }
  constructor(props) {
    super(props)
    this.state = {
      point: props.point || 0,
      rankpoint: 0,
      remaining_amount: 0,
      tblwheelsetting: [],
      name: "",
      password: "",
      left: false,
      disable: false,
      segColors: null,
      segments: null
    }
  }
componentDidUpdate(prevProps, prevState) {
    const { point, userid } = this.props; // destructuring for easier access

    // Check if point has changed
    if (prevProps.point !== point) {
        if (point !== this.state.point) {
            console.log("componentDidUpdate - point updated:", point);
            this.setState({ point });
        }
    }

    // Check if username has changed
    if (prevProps.userid !== userid) {
        if (userid !== this.state.userid) {
            console.log("componentDidUpdate - username updated:", userid);
            this.setState({ userid: userid });
        }
    }
}

  componentDidMount() {
    this.getwheel();
  }
  getwheel = async () => {
    // var segments = [{ id: 1, name: '5 บาท' }, { id: 2, name: '100 บาท' }, { id: 3, name: '300 บาท' }, { id: 4, name: '10 บาท' }, { id: 5, name: '20 บาท' }, { id: 6, name: 'คร้งหน้านะ บาท' }, { id: 7, name: 'เกือบได้แล้ว' }, { id: 8, name: 'ครั้งหน้านะ' }, { id: 9, name: '1000 บาท' }];
    try {
      await instance.post("/api/v1/getwheelspin", {
        System: Systems,
      }).then((res) => {
        console.log("getwheelspin", res.data)
        if (res.data.status === 200) {
          const datas = res.data.message;
          var segments = []
          var segColors = []
          for (var i = 0; i < datas.length; i++) {
            var id = datas[i].id
            var name = datas[i].description
            var color = datas[i].color
            var image = datas[i].image
            var setp = { id, name, image }
            segments.push(setp)
            segColors.push(color)
          }
          console.log(segColors)
          this.setState({
            tblwheelsetting: res.data.tblwheelsetting,
            segments: segments,
            segColors: segColors,
          });
          console.log(61, segments)


        }
        else {
          // this.CheckThisGoalError();
        }
      });
    }
    catch (error) {
      console.log(error)
    }



  }

  render() {
    // console.log(555555, this.state.segments)
    const lang = this.lang;
    return (
      <>
        <br></br>
        <br></br>
        <br></br>
        <div className="-full-flex-wrap ">
          <div className="-full-flex-inner-bg -bg" style={{ backgroundImage: 'url(/build/web/igame-index-lobby-wm/img/index-bg.jpg?v=1)' }}>
            <div className="x-lucky-wheel-share-component  x-bg-position-center lazyloaded" data-bgset="/build/web/igame-index-lobby-wm/img/wheel-page-bg.jpg?v=1" style={{ backgroundImage: 'url("/build/web/igame-index-lobby-wm/img/wheel-page-bg.jpg?v=1")' }}>
              <div className="container position-relative">
                <div className="-btn-info-wrapper animated fadeInUp" data-animatable="fadeInUp">
                  <button className="btn -btn-info " data-ajax-modal-ondemand-user="lucky-wheel-modal-history" data-force="true" data-x-dismiss="true" data-parent-class-selector="x-lucky-wheel-history-modal -v2" data-url="/_ajax_/lucky-fortune/history?promotionId=9">
                    <i className="fas fa-history" />
                  </button>
                  <button className="btn -btn-info " data-toggle="modal" data-target="#luckyWheelConditionModal">
                    <i className="fas fa-info-circle" />
                  </button>
                </div>
              </div>
              <div className="text-center mb-4">
                <h1 className="-heading-title animated fadeInUp" data-animatable="fadeInUp">{t(lang, 'ft_wheel_title')}</h1>
              </div>
              <div className="container">
                <div id="wheel" data-animatable="fadeInUp" data-delay={250} className="x-wheel-container x-bg-position-center lazyloaded animated fadeInUp" data-bgset="https://asset.cloudigame.co/build/admin/img/wt_theme/ezc/wheel-bg.png" style={{ backgroundImage: 'url("https://asset.cloudigame.co/build/admin/img/wt_theme/ezc/wheel-bg.png")' }}>
                  <img alt="Website name Image" className="-wheel-ring" width={528} height={528} src="https://asset.cloudigame.co/build/admin/img/wt_theme/ezc/wheel-ring.png" />
                  <div className="-center-pin">
                    <img alt="Website name Image" className="-wheel-pin" width={112} height={171} src="https://asset.cloudigame.co/build/admin/img/wt_theme/ezc/wheel-pin.png" />
                <img src="" alt="กงล้อพารวย กงล้อมหาสนุก" id="rewardImgCenter" className="-reward-img" />
                  </div>
                  {(this.state.segments === null || this.state.segments.length == 0) ? "" :
                    <div className={"x-wheel-inner-wrapper -length-" + (this.state.segments.length)} style={{ "--wheel-length": (this.state.segments.length) }} >
                      <div id="wheelSpinner" className="-spinner">
                        {this.state.segments.map((listitem, i) => (
                          <div id={"wheelRewardKey_" + listitem.id} className={"-wheel-section whell" + listitem.id}  >
                            <div className="-wheel-content-wrapper">
                              <div className="-text">{listitem.name}</div>
                              <img src={listitem.image} className="-img" alt="กงล้อพารวย กงล้อมหาสนุก" width={30} height={30} />
                            </div>
                          </div>

                        ))}
                      </div>
                    </div>
                  }

                </div >
                <button className={this.state.point > 0 ? "btn -btn-spin js-wheel-button animated fadeInUp" : "btn -btn-spin js-wheel-button disabled animated fadeInUp"} data-animatable="fadeInUp" data-delay={200} disabled={this.state.point <= 0}>
                  <span className="-text ">{t(lang, 'ft_spin_wheel')}</span>
                  <img alt="Website name Image" className="img-fluid" width={30} height={30} src="https://asset.cloudigame.co/build/admin/img/wt_theme/ezc/wheel-ticket.png" />
                  <span className="-text js-spin-ticket">{this.state.point}</span>
                </button>
                <audio id="sfx-wheel-spinning" src="https://asset.cloudigame.co/build/admin/img/wt_theme/ezl/sfx-wheel-spinning.mp3" />
                <audio id="sfx-wheel-got-reward" src="https://asset.cloudigame.co/build/admin/img/wt_theme/ezl/sfx-wheel-got-reward.mp3" />
              </div >
              <div className="x-wheel-progress-wrapper">
                <div className="container">
                  <div className="-inner-wrapper animated fadeInUp" data-animatable="fadeInUp">
                    <div>{t(lang, 'ft_deposit_get_ticket_1')} {this.state.tblwheelsetting.length > 0 ? this.state.tblwheelsetting[0].amount : 0} {t(lang, 'ft_deposit_get_ticket_2')}</div>
                    <div className="progress -progress mt-2">
                      <div
                        className="progress-bar"
                        role="progressbar"
                        style={{
                          width:
                            this.state.tblwheelsetting.length > 0 && this.state.tblwheelsetting[0].amount > 0
                              ? (this.state.remaining_amount / this.state.tblwheelsetting[0].amount) * 100 + '%'
                              : '0%', // Default to 0% if amount is not available
                        }}
                        aria-valuenow={0}
                        aria-valuemin={0}
                        aria-valuemax={100}
                      />

                      {/* <div className="progress-bar -progress-bar" role="progressbar" style={{ width: (this.state.remaining_amount-this.state.tblwheelsetting[0].amount ) +'%' }} aria-valuenow={0} aria-valuemin={0} aria-valuemax={100} /> */}
                      <span className="-label">{this.state.remaining_amount}/{this.state.tblwheelsetting.length > 0 ? this.state.tblwheelsetting[0].amount : 0} </span>
                    </div>
                  </div>
                </div>
              </div>
            </div >
            <div className="x-modal modal " id="luckyWheelConditionModal" tabIndex={-1} role="dialog" aria-hidden="true" data-loading-container=".js-modal-content" data-ajax-modal-always-reload="true">
              <div className="modal-dialog -modal-size  modal-dialog-centered modal-dialog-scrollable -modal-medium" role="document">
                <div className="modal-content -modal-content">
                  <button type="button" className="close f-1 " data-dismiss="modal" aria-label="Close">
                    <i className="fas fa-times" />
                  </button>
                  <div className="modal-header -modal-header">
                    <h3 className="x-title-modal d-inline-block m-auto">
                      {t(lang, 'ft_terms_of_service')}                          </h3>
                  </div>
                  <div className="modal-body -modal-body">
                    <div className="x-lucky-wheel-condition-container">
                      <p>{t(lang, 'ft_wheel_term_1')}<br />
                        {t(lang, 'ft_wheel_term_2_a')}<span style={{ color: '#f39c12' }}><u><strong>{t(lang, 'ft_wheel_term_2_reset')}</strong></u></span>{t(lang, 'ft_wheel_term_2_b')}</p>
                      <p><span style={{ color: '#e74c3c' }}>{t(lang, 'ft_wheel_term_3')}</span></p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="x-modal modal  " id="luckyWheelResultModal" tabIndex={-1} role="dialog" aria-hidden="true" data-loading-container=".js-modal-content" data-ajax-modal-always-reload="true">
              <div className="modal-dialog -modal-size  modal-dialog-centered modal-dialog-scrollable " role="document">
                <div className="modal-content -modal-content">
                  {/* <button type="button" className="close f-1 " data-dismiss="modal" aria-label="Close">
                    <i className="fas fa-times" />
                  </button> */}
                  <div className="modal-header -modal-header">
                    <h3 className="x-title-modal d-inline-block m-auto">
                      {t(lang, 'ft_congratulations')}                          </h3>
                  </div>
                  <div className="modal-body -modal-body">
                    <div className="x-wheel-result-modal-container">
                      <p className="js-modal-wheel-result-description -description" />
                      <div className="-reward-image-wrapper">
                        <img alt="Website name Image" className="-img-bg img-fluid" src="https://asset.cloudigame.co/build/admin/img/wt_theme/ezc/wheel-reward-effect-bg.png" />
                      <img src="" alt="กงล้อพารวย กงล้อมหาสนุก" id="rewardImgCenter" className="-reward-img" />
                      </div>
                      <button className="btn -btn-close-modal" data-dismiss="modal">
                        {t(lang, 'ft_close')}
                      </button>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div >
        </div >




      </>
    );
  }
}
export default App;



